export const LIVE_HOSTS = new Set(["sellavo.com", "www.sellavo.com"]);

export function isLiveHostname(hostname: string): boolean {
  return LIVE_HOSTS.has(hostname.toLowerCase().split(":")[0] ?? "");
}

export function isTestHostname(hostname: string): boolean {
  return !isLiveHostname(hostname);
}

export function requestHostname(request: Request): string {
  const forwarded = request.headers.get("x-forwarded-host")?.split(",")[0]?.trim();
  const host = forwarded || request.headers.get("host") || "sellavo.com";
  return host.split(":")[0]?.toLowerCase() ?? "sellavo.com";
}